import { SvgSC } from './styles'

const OutOfZoneIcon = ({ className = '', width = 50, height = 50 }) => (
  <SvgSC
    width={width}
    height={height}
    className={className}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.9963 24.5637C50.2372 38.3684 38.8073 49.7553 25 49.9962C11.195 50.2348 0.242383 39.2388 0.00373943 25.4341C-0.237177 11.6339 11.195 0.242481 25 0.00388134C38.805 -0.236991 49.7576 10.7636 49.9963 24.5637Z"
      fill="var(--secondaryColor)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3177 16.7423C16.3478 18.1783 15.7819 19.9119 15.7819 21.783C15.7819 24.9188 18.7511 29.7261 24.7819 35.9412C27.004 33.6511 28.8105 31.5522 30.2059 29.6576L17.3177 16.7423ZM32.1219 26.7442C33.231 24.7944 33.7819 23.1336 33.7819 21.783C33.7819 16.7941 29.7588 12.783 24.7819 12.783C22.9082 12.783 21.1698 13.3514 19.7303 14.3265L32.1219 26.7442Z"
      fill="var(--bgColor)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8829 15.3046C14.562 17.1173 13.7819 19.3535 13.7819 21.783C13.7819 25.857 17.4485 31.5237 24.7819 38.783C27.6123 35.9811 29.8965 33.4165 31.6345 31.0892L30.2059 29.6576C28.8105 31.5522 27.004 33.6511 24.7819 35.9412C18.7511 29.7261 15.7819 24.9188 15.7819 21.783C15.7819 19.9119 16.3478 18.1783 17.3177 16.7423L15.8829 15.3046ZM21.0115 20.4439C20.8628 20.8626 20.7819 21.3133 20.7819 21.783C20.7819 23.9921 22.5727 25.783 24.7819 25.783C25.2485 25.783 25.6966 25.703 26.113 25.5561L21.0115 20.4439ZM28.5403 23.1551L23.4176 18.0216C23.8434 17.8672 24.3028 17.783 24.7819 17.783C26.991 17.783 28.7819 19.5738 28.7819 21.783C28.7819 22.265 28.6966 22.7271 28.5403 23.1551ZM32.1219 26.7442C33.231 24.7944 33.7819 23.1336 33.7819 21.783C33.7819 16.7941 29.7588 12.783 24.7819 12.783C22.9082 12.783 21.1698 13.3514 19.7303 14.3265L18.2969 12.8901C20.1167 11.5633 22.3593 10.783 24.7819 10.783C30.8456 10.783 35.7819 15.6718 35.7819 21.783C35.7819 23.6054 35.0482 25.7464 33.5808 28.2062L32.1219 26.7442Z"
      fill="var(--primaryColor)"
    />
    <path
      d="M12.7819 13.1958L14.1986 11.783L35.7819 33.3701L34.3651 34.783L12.7819 13.1958Z"
      fill="var(--primaryColor)"
    />
  </SvgSC>
)

export default OutOfZoneIcon
